import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=02b64790&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=02b64790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b64790",
  null
  
)

export default component.exports